import axios from "axios";

const api = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
  },
});

const sickleApi = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry && originalRequest.url.includes("portal")
    ) {
      originalRequest._retry = true;
      try {

        const formData = new FormData();
        const rtoken = localStorage.getItem("NCD_refresh_token");

        formData.append("grant_type", "refresh_token");
        formData.append("refresh_token", rtoken);

        const response = await axios.post("/portal/cphc-auth/oauth/token", formData, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          auth: { username: "NCDBrowser", password: "SecureNCD" },
        });

        const newAccessToken = response.data.access_token;

        localStorage.setItem("NCD_token", newAccessToken); // Update stored access token
        localStorage.setItem("NCD_refresh_token", response.data.refresh_token);
        
        api.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        return api(originalRequest); // Retry the original request
      } catch (refreshError) {

        console.error("Token refresh failed:", refreshError);
        // Redirect to login or handle session expiration
       // localStorage.clear();
        //window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

sickleApi.interceptors.response.use(
  (response) => response,

  // async (error) => {
  //   const originalRequest = error.config;
  //   if (
  //     error.response &&
  //     error.response.status === 401 &&
  //     !originalRequest._retry && originalRequest.url.includes("sickle2staging")
  //   ) {
  //     originalRequest._retry = true;
  //     try {

  //       const sickle_refresh_token = localStorage.getItem("sickle_refresh_token");

  //       const response = await axios.post(
  //         'sickle2staging/api/facilitylogin2/refresh_token',
  //         {},
  //         {
  //           headers: {
  //             Authorization: `Bearer ${sickle_refresh_token}`,
  //           },
  //         }
  //       );

  //       const newSickleToken = response.data.result.token;
        
  //       localStorage.setItem("sickle_token", newSickleToken);
        
  //       // api.defaults.headers.common["Authorization"] = `Bearer ${newSickleToken}`;
  //       // originalRequest.headers["Authorization"] = `Bearer ${newSickleToken}`;

  //       return api(originalRequest); // Retry the original request

  //     } catch (refreshError) {

  //       console.error("Token refresh failed:", refreshError);
  //       // Redirect to login or handle session expiration
  //      // localStorage.clear();
  //      // window.location.href = "/";
  //     }
  //   }
  //   return Promise.reject(error);
  // }

);

export { api, sickleApi };
